import { render } from "./Loan_Statement.vue?vue&type=template&id=e0ac23e0&scoped=true"
import script from "./Loan_Statement.vue?vue&type=script&lang=js"
export * from "./Loan_Statement.vue?vue&type=script&lang=js"

import "./Loan_Statement.vue?vue&type=style&index=0&id=e0ac23e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ac23e0"]])

export default __exports__